import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@diametral/design-system/react";

export interface SelectOption {
  /** "" stands for "no value" (e.g. "Tous"); it maps to Base UI's null item. */
  value: string;
  label: string;
  disabled?: boolean;
}

interface SelectFieldProps {
  /** Accessible name of the trigger (a visible label can sit next to it as well). */
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  id?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: "sm" | "default";
}

/** The DS Select (Base UI popup) driven by a flat options array. */
export function SelectField({ label, value, onChange, options, id, placeholder, disabled, size }: SelectFieldProps) {
  const items = options.map((o) => ({ value: o.value === "" ? null : o.value, label: o.label }));
  return (
    <Select
      items={items}
      value={value === "" ? null : value}
      onValueChange={(next: string | null) => onChange(next ?? "")}
      disabled={disabled}
    >
      <SelectTrigger id={id} aria-label={label} size={size}>
        <SelectValue placeholder={placeholder ?? label} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value || "__none__"}
            value={option.value === "" ? null : option.value}
            disabled={option.disabled}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
